{
  "title": "Пользователи и доступ",
  "intro": "Все люди вашей организации: что им можно и в каких проектах. Приглашайте по одноразовой ссылке; откройте человека, чтобы поменять его роль или доступ.",
  "inviteAction": "Пригласить",
  "search": "Поиск по имени или e-mail",
  "filter": "Показать",
  "filters": {
    "all": "Всех",
    "admin": "Администраторов",
    "project_owner": "Владельцев проектов",
    "guest": "Гостей",
    "mixed": "Владельцев и гостей",
    "none": "Без проектов",
    "invited": "Приглашённых"
  },
  "empty": "Никого не нашлось",
  "emptyLead": "Под поиск никто не подходит. Пригласите коллегу: он получит ссылку, чтобы задать пароль и второй фактор.",
  "name": "Имя",
  "kind": "Вид",
  "projects": "Проекты",
  "allProjects": "Все проекты",
  "secondFactor": "Второй фактор",
  "factorOn": "Включён",
  "factorOff": "Не настроен",
  "lastSignIn": "Последний вход",
  "never": "Никогда",
  "statusLabel": "Статус",
  "organizationOwner": "Владелец организации",
  "kinds": {
    "admin": "Администратор",
    "project_owner": "Владелец проекта",
    "guest": "Гость",
    "mixed": "Владелец и гость",
    "none": "Без проектов"
  },
  "status": {
    "active": "Активен",
    "invited": "Приглашён",
    "suspended": "Заблокирован"
  },
  "access": {
    "admin": "Администратор",
    "owner": "Владелец",
    "guest": "Гость",
    "none": "Нет доступа"
  },
  "projectWithAccess": "{{name}} ({{access}})",
  "accessIn": "Доступ к проекту {{name}}",
  "projectsLabel": "Проекты",
  "projectsHint": "Владелец — полные права в проекте в пределах его бюджета. Гость — только смотрит: без изменений, консоли и паролей root. Проект без доступа человеку не виден.",
  "noProjects": "Проектов пока нет.",
  "role": {
    "label": "Вид пользователя",
    "hint": "Администраторы видят и делают всё, включая пользователей и подключения к провайдеру. Участники получают права по проектам.",
    "admin": "Администратор",
    "adminLead": "Видит и делает всё: все проекты, подключения, пользователей и их доступ.",
    "member": "Участник",
    "memberLead": "Работает только в выданных ниже проектах — как владелец или гость."
  },
  "open": "Открыть",
  "inviteAgain": "Пригласить снова",
  "revoke": "Отозвать приглашение",
  "revoked": "Приглашение для {{email}} отозвано",
  "invitationExpires": "Ссылка истекает {{when}}",
  "invitationExpired": "Ссылка истекла",
  "invite": {
    "title": "Пригласить человека",
    "lead": "Он получит одноразовую ссылку на 7 дней, чтобы задать пароль и второй фактор.",
    "email": "E-mail",
    "submit": "Создать ссылку",
    "createdTitle": "Ссылка-приглашение",
    "createdLead": "Отправьте эту ссылку на {{email}} сами: CloudServer пока не рассылает письма.",
    "link": "Одноразовая ссылка",
    "linkHint": "Действует 7 дней и срабатывает один раз. Показывается только сейчас — скопируйте её, прежде чем закрыть.",
    "copy": "Скопировать ссылку",
    "copied": "Ссылка скопирована",
    "copyFailed": "Не удалось скопировать; выделите ссылку и скопируйте вручную",
    "done": "Готово"
  },
  "stepUp": {
    "title": "Подтвердите, что это вы",
    "lead": "Чтобы менять, кому что можно, нужен ваш второй фактор. Одно подтверждение действует пять минут.",
    "passkey": "Подтвердить passkey",
    "code": "Код из приложения-аутентификатора",
    "confirm": "Подтвердить"
  },
  "roleSection": "Роль в организации",
  "roleSectionLead": "Администраторы видят всё; участники работают в выданных им проектах.",
  "lockedSelf": "Это вы: свою роль и статус меняет другой администратор.",
  "lockedOwner": "Владелец организации всегда остаётся администратором.",
  "saveRole": "Сохранить роль",
  "roleSaved": "Роль {{name}} изменена",
  "projectsSection": "Доступ к проектам",
  "projectsSectionLead": "Какие проекты человек видит и может ли их менять.",
  "adminSeesAll": "Администраторы видят и меняют все проекты; здесь нечего настраивать.",
  "saveAccess": "Сохранить доступ",
  "accessSaved": "Доступ {{name}} изменён",
  "securitySection": "Второй фактор",
  "securitySectionLead": "Каждому нужен passkey или приложение-аутентификатор. Сбросьте, если человек потерял устройство.",
  "passkeys": "Passkeys",
  "authenticator": "Приложение-аутентификатор",
  "reset": "Сбросить второй фактор",
  "resetSelf": "Свои факторы — на странице «Вход и безопасность».",
  "resetTitle": "Сбросить второй фактор {{name}}?",
  "resetFactors": "Его passkeys и приложение-аутентификатор удаляются.",
  "resetSessions": "Он сразу выходит на всех устройствах.",
  "resetNext": "Он входит по паролю и настраивает новый фактор, прежде чем работать.",
  "resetDone": "Второй фактор {{name}} сброшен",
  "sessionsSection": "Сеансы",
  "sessionsSectionLead": "Устройства, на которых человек сейчас вошёл.",
  "noSessions": "Нигде не вошёл.",
  "unknownDevice": "Неизвестное устройство",
  "sessionMeta": "{{ip}} · активен {{seen}}",
  "activitySection": "Недавние действия",
  "activitySectionLead": "Что человек делал в последнее время, по журналу аудита.",
  "noActivity": "Пока ничего не записано.",
  "outcome": {
    "success": "Выполнено",
    "denied": "Отказано",
    "failed": "Ошибка"
  },
  "dangerSection": "Заблокировать или удалить",
  "dangerSectionLead": "Блокировку можно снять; удаление необратимо.",
  "suspend": "Заблокировать",
  "suspendTitle": "Заблокировать {{name}}?",
  "suspendSessions": "Он сразу выходит на всех устройствах.",
  "suspendSignIn": "Он не сможет войти, пока его не разблокируют.",
  "suspendKeep": "Учётная запись и доступ к проектам сохраняются.",
  "suspended": "{{name}} заблокирован",
  "reactivate": "Разблокировать",
  "reactivateTitle": "Разблокировать {{name}}?",
  "reactivateLead": "Он снова сможет войти с прежним доступом.",
  "reactivated": "{{name}} снова может войти",
  "remove": "Удалить",
  "removeTitle": "Удалить {{name}}?",
  "removeAccount": "Учётная запись, сеансы и вторые факторы удаляются.",
  "removeHistory": "Его действия остаются в истории и журнале аудита.",
  "removeAgain": "Чтобы снова работать здесь, ему нужно новое приглашение.",
  "removed": "{{name}} удалён"
}
